import { Injectable, inject } from '@angular/core';
import { IRelatedProductsCallback, RelatedProductsService } from '@df/catalog-ui/related-products/related-products.service';
import { ICategoryDataV2 } from '@df/catalog/category/category';
import { CategoryResource } from '@df/catalog/category/category.resource';
import { IProductDataV2 } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import flatten from 'lodash-es/flatten';
import shuffle from 'lodash-es/shuffle';
import take from 'lodash-es/take';
import uniq from 'lodash-es/uniq';

export interface ICategoryEngineOptions {
    // force category ids
    categoryIds?: number[];
}

@Injectable({
    providedIn: 'root'
})
export class CategoryEngine {
    private productResource = inject(ProductResource);
    private categoryResource = inject(CategoryResource);

    get(sourceIds: number[], cb: IRelatedProductsCallback, options: ICategoryEngineOptions | undefined) {
        const categoryIds: number[] =
            options?.categoryIds ||
            uniq(
                this.productResource
                    .getAllExisting(sourceIds)
                    .map(model => ((<IProductDataV2>model.data).categories ? (<IProductDataV2>model.data!).categories?.last : undefined))
                    .filter(item => !!item) as number[]
            );

        if (Array.isArray(categoryIds) && categoryIds.length) {
            this.categoryResource.loadAllIds(categoryIds, 2, { safe: true }).then(categories => {
                cb(
                    shuffle(
                        flatten(categories.map(category => take(category.data ? (<ICategoryDataV2>category.data).products || [] : [], 100)))
                    )
                );
            });
        } else {
            cb([]);
        }
    }
}

RelatedProductsService.registerEngine('category', CategoryEngine);
